module.exports = __webpack_public_path__ + "static/img/new-gogo-logo.010b230.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/new-gogo-logo.svg
// module id = 214
// module chunks = 1